<template>
    <div class="family-patents-loading">
        <div
            v-for="item in 3"
            :key="item"
            class="pa-p-4"
        >
            <div class="pa-flex">
                <span class="pa-mr-2 pa-h-4 pa-w-4 pa-rounded pa-bg-gray-30" />
                <span class="pa-h-4 pa-w-[160px] pa-rounded pa-bg-gray-30" />
            </div>
            <div
                v-if="!isFamilySearchFromWorkspace"
                class="pa-mt-2 pa-flex"
            >
                <span class="pa-mr-2 pa-h-4 pa-w-[48px] pa-rounded pa-bg-gray-30" />
                <span class="pa-mr-2 pa-h-4 pa-w-[48px] pa-rounded pa-bg-gray-30" />
                <span class="pa-mr-2 pa-h-4 pa-w-[48px] pa-rounded pa-bg-gray-30" />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useFamilySearch } from '@/composables/use-family-search';

const { isFamilySearchFromWorkspace } = useFamilySearch();
</script>
<style lang="scss">

</style>
